import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../utils/type';
import {
  selectVendorChargerStatus,
  selectVendorChargerStatusLoading,
  selectVendorChargerStatusError,
} from '../services/chargerStatus/selectors';
import { getVendorChargerStatus } from '../services/chargerStatus/crudFunctions';
import LoadingSpinner from '../../../elements/LoadingSpinner';
import ChargerTable from '../../../elements/ChargerTable';
import StationSelect from '../../../elements/StationSelect';

const VendorChargerStatus: React.FC = () => {
  const dispatch = useDispatch();
  const data = useSelector((s: RootState) => selectVendorChargerStatus(s));
  const loading = useSelector((s: RootState) => selectVendorChargerStatusLoading(s));
  const error = useSelector((s: RootState) => selectVendorChargerStatusError(s));

  const [stationId, setStationId] = useState<number | undefined>();

  useEffect(() => {
    dispatch<any>(getVendorChargerStatus());
  }, [dispatch]);

  const handleFilter = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch<any>(getVendorChargerStatus(stationId));
  };

  return (
    <div>
      <div className="page-title">
        <div className="title_left">
          <h3>
            <i className="bi bi-plug me-2 text-success" />
            My Charger Status
          </h3>
        </div>
      </div>

      <div className="x_panel">
        <div className="x_title">
          <h4>Filters</h4>
          <div className="clearfix" />
        </div>
        <div className="x_content">
          {error && (
            <div className="alert alert-danger">
              <i className="fas fa-exclamation-triangle me-2" />
              {error}
            </div>
          )}
          <form onSubmit={handleFilter}>
            <div className="row g-3 mb-3">
              <div className="col-md-4">
                <StationSelect
                  vendorId={undefined}
                  value={stationId}
                  onChange={setStationId}
                />
              </div>
            </div>
            <div className="row g-3">
              <div className="col-12">
                <button type="submit" className="btn btn-success px-4">
                  <i className="fas fa-search me-2" /> Apply Filters
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      {loading ? <LoadingSpinner /> : <ChargerTable data={data} />}
    </div>
  );
};

export default VendorChargerStatus;
